import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export const AriaConsentCard = ({ settings, onChange }) => {
  const { t, i18n } = useTranslation();
  const [checked, setChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  const accept = async () => {
    setSaving(true);
    try {
      const { data } = await api.post('/aria/consent', { accepted: true, text_version: settings.consent_version, locale: i18n.language });
      onChange(data);
      toast.success(t('aria.consent.saved'));
    } catch { toast.error(t('aria.error')); } finally { setSaving(false); }
  };

  return (
    <div className="rounded-2xl border border-violet-300/50 dark:border-violet-700/50 bg-violet-50/60 dark:bg-violet-950/30 p-4 sm:p-5 space-y-4" data-testid="aria-consent-card">
      <div className="flex items-start gap-3">
        <ShieldCheck className="h-6 w-6 text-violet-600 shrink-0 mt-0.5" aria-hidden="true" />
        <div className="space-y-1.5">
          <p className="font-semibold">{t('aria.consent.title')}</p>
          <p className="text-sm text-muted-foreground">{t('aria.consent.what')}</p>
          <p className="text-sm text-muted-foreground">{t('aria.consent.never')}</p>
          <p className="text-sm text-muted-foreground">{t('aria.consent.control')}</p>
        </div>
      </div>
      <label htmlFor="aria-consent-check" className="flex items-start gap-3 rounded-xl bg-background/70 p-3 cursor-pointer">
        <Checkbox id="aria-consent-check" checked={checked} onCheckedChange={(v) => setChecked(v === true)} className="mt-0.5" data-testid="aria-consent-checkbox" />
        <span className="text-sm">{t('aria.consent.text')}</span>
      </label>
      <Button onClick={accept} disabled={!checked || saving} className="w-full min-h-[48px] bg-violet-600 hover:bg-violet-700 text-white" data-testid="aria-consent-accept">
        {saving && <Loader2 className="h-4 w-4 animate-spin mr-2" />}{t('aria.consent.accept')}
      </Button>
      <p className="text-xs text-muted-foreground text-center">{t('aria.consent.basic')}</p>
    </div>
  );
};
